document.documentElement.classList.add("bonum-js-ok");

function applyAnnouncementStyle() {
  const span = Array.from(document.querySelectorAll("span"))
    .find(s => (s.textContent || "").trim().includes("Envio rápido em Portugal"));

  if (!span) return;

  const container =
    span.closest('[id*="announcement"]') ||
    span.closest('[class*="announcement"]') ||
    span.closest('[class*="utility"]') ||
    span.closest("section") ||
    span.closest("div");

  if (!container) return;

  container.classList.add("bonum-announcement");
}

document.addEventListener("DOMContentLoaded", applyAnnouncementStyle);
window.addEventListener("load", applyAnnouncementStyle);